var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourInternshipGrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14108",
    "data-name": "Group 14108",
    transform: "translate(-1321 -3102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14100",
    "data-name": "Group 14100",
    transform: "translate(74 -1866)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 43,
    height: 40,
    rx: 12,
    transform: "translate(1247 4968)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Knowledge",
    transform: "translate(1235.5 3069.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5238",
    "data-name": "Path 5238",
    d: "M276.311,258.577l-7.186,1.6v10.28l7.5-1.669a.733.733,0,0,0,.578-.715v-8.777a.732.732,0,0,0-.891-.715Zm-1.033,7.93-3.916.871a.735.735,0,0,1-.318-1.434l3.916-.871A.735.735,0,0,1,275.279,266.507Zm0-3.427-3.916.871a.735.735,0,0,1-.318-1.434l3.916-.871A.735.735,0,0,1,275.279,263.08Z",
    transform: "translate(-161.079 -205.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5239",
    "data-name": "Path 5239",
    d: "M98.5,259.283v8.777a.728.728,0,0,0,.573.715l7.5,1.669v-10.28l-7.186-1.6a.73.73,0,0,0-.891.715Zm2.237,2.257,3.916.871a.735.735,0,1,1-.318,1.434l-3.916-.871a.735.735,0,0,1,.318-1.434Zm0,3.427,3.916.871a.735.735,0,0,1-.318,1.434l-3.916-.871a.735.735,0,0,1,.318-1.434Z",
    transform: "translate(0 -205.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5240",
    "data-name": "Path 5240",
    d: "M220.8,198.411h-4.406A2.245,2.245,0,1,0,220.8,198.411Z",
    transform: "translate(-111.282 -148.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5241",
    "data-name": "Path 5241",
    d: "M197.478,60.467h3.6l.945-1.341a3.347,3.347,0,1,0-5.483,0Z",
    transform: "translate(-91.968 -12.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5242",
    "data-name": "Path 5242",
    d: "M332.9,153.786c.241.112.864.582,1.143.547a.738.738,0,0,0,.368-1.37l-.776-.448A.734.734,0,0,0,332.9,153.786Z",
    transform: "translate(-220.941 -105.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5243",
    "data-name": "Path 5243",
    d: "M140.533,152.52l-.777.448a.738.738,0,0,0,.368,1.371c.282.033.9-.434,1.144-.547A.735.735,0,0,0,140.533,152.52Z",
    transform: "translate(-38.606 -105.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5244",
    "data-name": "Path 5244",
    d: "M346.4,101.472a.734.734,0,0,0,.734.734h.9a.734.734,0,0,0,0-1.469h-.9a.734.734,0,0,0-.734.734Z",
    transform: "translate(-234.028 -56.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5245",
    "data-name": "Path 5245",
    d: "M124.014,102.207h.9a.734.734,0,0,0,0-1.469h-.9a.734.734,0,0,0,0,1.469Z",
    transform: "translate(-23.394 -56.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5246",
    "data-name": "Path 5246",
    d: "M333.349,42.775c.282.033.9-.434,1.143-.547a.734.734,0,0,0-.734-1.272l-.776.448A.738.738,0,0,0,333.349,42.775Z",
    transform: "translate(-221.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5247",
    "data-name": "Path 5247",
    d: "M139.674,42.232c.241.112.864.582,1.144.547a.738.738,0,0,0,.368-1.371l-.777-.448A.734.734,0,0,0,139.674,42.232Z",
    transform: "translate(-38.525 -0.005)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourInternshipGrow);
export default __webpack_public_path__ + "static/media/your-internship-grow.7465ec46c65dc9c06a99fb32f43e0668.svg";
export { ForwardRef as ReactComponent };